export default "__VITE_ASSET__kxDvOCys__"